import { Component } from '@theme/component';

/**
 * Upsell vase picker: checkboxes that behave as a single choice that can be cleared by clicking the
 * selected vase again. The checked input is read by `product-form-component` at add-to-cart time.
 *
 * @extends {Component}
 */
class ProductVaseSelector extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#onChange);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const { target } = event;
    if (!(target instanceof HTMLInputElement) || !target.checked) return;

    /** @type {NodeListOf<HTMLInputElement>} */
    const inputs = this.querySelectorAll('input[data-additional-item-variant-id]:checked');
    for (const input of inputs) {
      if (input !== target) input.checked = false;
    }
  };
}

if (!customElements.get('product-vase-selector')) {
  customElements.define('product-vase-selector', ProductVaseSelector);
}
